import { toggleMenuTabIndex, toggleTabIndex } from './toggleTabIndex';

const toggleMapping = {
    'toggle': 'toggle',
    'show': 'add',
    'hide': 'remove',
};

const collapse = ( selector, cmd, toggleClass ) => {
    if ( typeof selector === 'object' ) {
        selector.classList[ toggleMapping[ cmd ] ]( toggleClass );
    } else {
        Array.from( document.querySelectorAll( selector ) ).forEach( target => {
            target.classList[ toggleMapping[ cmd ] ]( toggleClass );
        } );
    }
}

function Toggle() {

    const triggers = Array.from( document.querySelectorAll( '[data-toggle="collapse"]' ) );
    if ( ! triggers ) {
        return;
    }

    window.addEventListener( 'click', ( e ) => {
        const el = e.target;

        if ( triggers.includes( el ) ) {

            collapse( el.getAttribute( 'data-target' ), 'toggle', el.getAttribute( 'data-target-class' ) || 'show' );
            toggleProperty( el, 'aria-expanded' );

            // Update controller aria-hidden attribute.
            if ( !!el.hasAttribute( 'aria-controls' ) ) {
                toggleProperty( document.getElementById( el.getAttribute( 'aria-controls' ) ), 'aria-hidden' );
            }
        }

        if ( triggers.includes( el.parentNode ) ) {
            collapse( el.parentNode.getAttribute( 'data-target' ), 'toggle', el.parentNode.getAttribute( 'data-target-class' ) || 'show' );
            toggleProperty( el.parentNode, 'aria-expanded' );
        }

        // Fire click on inner-link after firing toggle.
        if ( el.classList.contains( 'js-menu-item-readspeaker' ) ) {
            el.querySelector( 'a' ).click();
        }

        if ( 'menuToggle' === el?.getAttribute( 'id' ) ) {
            // Check menu-status.
            const active = document.body.classList.contains( 'menu-active' );

            // Toggle Primary menu status.
            const primary_menu = document.getElementById( 'menu-main-menu' );
            if ( primary_menu ) {
                toggleMenuTabIndex( primary_menu, ! active );
            }

            // Toggle Topbar menu status.
            const topbar_menu = document.getElementById( 'menu-topbar' );
            if ( topbar_menu ) {
                toggleMenuTabIndex( topbar_menu, ! active );
            }

            // Toggle main elements.
            toggleTabIndex( 'site-content', !! active );
            toggleTabIndex( 'site-footer', !! active );

            // Loop through `<UL>` since mobile-menu is ul + ul.
            [ ...document.getElementById( 'mobile-menu' ).children ].forEach( el => {
                toggleMenuTabIndex( el, active );
            } );
        }

        if ( !! el.parentNode && el.parentNode.classList.contains( 'menu-item-has-children' ) && el.dataset.target ) {
            const status = 'true' === el.getAttribute( 'aria-expanded' );
            toggleMenuTabIndex( document.querySelector( el.dataset.target ), !! status );
        }

    }, false );
}

/**
 * Toggle specific property.
 *
 * @param {object} el HTML element.
 * @param {string} prop Property to update.
 */
const toggleProperty = ( el, prop ) => {
    if ( !!el && !!el.hasAttribute( prop ) ) {
        el.setAttribute( prop, ( el.getAttribute( prop ) === 'false' ? 'true' : 'false' ) );
    }
}

function ToggleWidget() {
    const triggers = Array.from( document.querySelectorAll( '[data-mobile-toggle="collapse"]' ) );
    if ( ! triggers || window.matchMedia( '(min-width: 991px)' ).matches ) {
        return;
    }

    window.addEventListener( 'click', ( ev ) => {
        const elm = ev.target;

        if ( triggers.includes( elm ) ) {
            collapse( elm.parentNode.querySelector( '.collapse' ), 'toggle', 'show' );
            toggleProperty( elm, 'aria-expanded' );
        }
    }, false );
}

export default {
    init() {
        Toggle();
        ToggleWidget();
    }
};
